module.exports = __webpack_public_path__ + "static/media/b3_p11_clickable_b.5f836049.mp3";